module.exports = __webpack_public_path__ + "img/icon_arrow_right_2.afa7498c.svg";